<template>
    <div id="popup-login-wrap" style="display:none; width: 100%; max-width: 660px; border-left: 10px solid #6fab00;">
        <h2 class="mb-3 text-center">
            {{ $t("會員登入") }}
        </h2><br/>

        <div>
                <h5>{{ $t("會員卡編號") }}</h5>
                    <input type="text" name="username" class="form-control" v-model="username"/>
        
        </div>

        <div>
            <h5>{{ $t("密碼") }}</h5>
            <input type="password" value="" name="password" class="form-control" v-model="password">
            <div class="error-msg" :class="{show:showError}"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>{{ $t("密碼錯誤") }}</div>
        </div>
        <p class="help-block"><a href="http://member.overlander.com.hk/" target="_blank">{{ $t("忘記密碼？") }}</a></p>
        <p class="mb-0 text-right">
            <a class="btn btn-primary btn-lg full-width" @click.prevent="onSubmit">{{ $t("登入") }}</a>
        </p>
    </div>

</template>

<script>
const i18n = new VueI18n({
  locale: "zh-hk",
  messages: {
    en: {
      會員登入: "Member login",
      會員卡編號: "Member number",
      密碼: "Password",
      密碼錯誤: "Password incorrect",
      "忘記密碼？": "Forget password?",
      登入: "Login"
    }
  }
});

module.exports = {
  name: "popup-login",
  i18n,
  data: function() {
    return {
      username: "",
      password: "",
      showError: false
    };
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  methods: {
    show() {
      $.fancybox.open($("#popup-login-wrap"));
    },
    onSubmit() {
      this.$http
        .post("member/login", {
          username: this.username,
          password: this.password
        })
        .then(resp => {
          if (resp.data.error) {
            this.showError = true;
          } else {
            window.self.location = resp.data.url;
          }
        });
    }
  }
};
</script>
